<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg">
          <div class="row full-height">
            <div class="col-md-8 col-md-offset-2 text-center full-height flex-v-center">
              <h1>Thank you for entering your item.</h1>
              <br>
              <a
                href=""
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="goItemSearch"
              >
                <span class="glyphicon-plus-sign glyphicon"></span> ADD ANOTHER ITEM FROM THIS INVOICE
              </a><br>
              <a
                href=""
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="finish"
              >
                SUBMIT FOR APPROVAL
              </a>
              <br><br>
              <a
                href=""
                type="button"
                class="btn client-btn-secondary btn-lg btn-block text-uppercase"
                @click.prevent="cancel"
              >
                Cancel
              </a>
              <br>
            </div>
          </div>
        </div>

        <div class="col-sm-6 invoice-details">
          <div class="row full-height">
            <div class="col-md-10 col-md-offset-1 text-center full-height flex-v-center">
              <h1 class="grey-type">ITEMS ENTERED</h1>
              <div class="choose-color text-left">
                <div class="invoice-details">
                  <p>Invoice/Receipt#: {{ invoiceData.receiptNumber }}</p>
                  <p>Date of Purchase: {{ formatDate(invoiceData.dateOfPurchase) }}</p>
                </div>

                <table id="invoice-items" cellspacing="0" cellpadding="0">
                  <thead>
                    <tr>
                      <th class="col-md-8">Name</th>
                      <th class="col-md-4">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item) in invoiceData.items" :key="item.item.id"
                      class="clickable grey-outline"
                      @click.prevent="goItemDetails(item)"
                      >
                      <td>{{ item.item.name }}</td>
                      <td>{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from 'axios'
axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

export default {
  name: 'ItemConfirmation',
  props: {
    item: {},
    invoiceData: {}
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('loyaltyProgram', ['program']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('receipt', [ 'cancelReceipt', 'finishReceipt' ]),
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    goItemSearch () {
      this.$bus.emit('swapComponent', { component: 'item-search' })
    },
    async cancel () {
      this.$bus.emit('global-load', { load: true, message: 'Canceling...', env: 'client' })
      try {
        const cancelationResults = await this.cancelReceipt({
          receiptId: this.invoiceData.receiptId
        })
        this.$bus.emit('global-load', { load: false })
        this.resetInvoiceData()
        this.goInvoiceDetails()
      } catch (error) {
        this.$bus.emit('global-load', { load: false })
        // console.log(error)
      }
    },
    async finish () {
      this.$bus.emit('global-load', { load: true, message: 'Finishing...', env: 'client' })
      try {
        const receiptResults = await this.finishReceipt({
          receiptNumber: this.invoiceData.receiptNumber
        })
        const emailResults = await axios.post(
          `${process.env.VUE_APP_SERVER_HOST}/api/common/mailer/rebateItemAdded`,
          {
            emailInfo: {
              to: this.user.email,
              company: this.program.company ? this.program.company.name : ''
            }
          }
        )
        this.$bus.emit('notify', { message: 'Submission successful.', type: 'info' })
      } catch (error) {
        console.log(error)
        this.$bus.emit('notify', { message: 'Submission failure, please try again.', type: 'danger' })
      } finally {
        this.$bus.emit('global-load', { load: false })
        this.goInvoiceEmail()
      }
    },
    goInvoiceEmail () {
      this.$bus.emit('swapComponent', { component: 'invoice-email' })
    },
    goInvoiceDetails () {
      this.$bus.emit('swapComponent', { component: 'invoice-details' })
    },
    resetInvoiceData () {
      this.invoiceData.dateOfPurchase = ''
      this.invoiceData.receiptNumber = ''
      this.invoiceData.receiptId = ''
      this.invoiceData.image = {
        url: null,
        fileName: null,
        randomString: null,
        imageKey: null
      }
      this.invoiceData.items = []
    }
  }
}
</script>

<style scoped>
.invoice-details {
  display: flex;
  justify-content: space-around;
  padding: 0 55px;
}

.flex-v-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.full-height {
  height: 100%;
}

.choose-color {
  background-color:  #FFF;
  padding: 15px;
  color: #464646;
  margin-bottom: 15px;
}

table#invoice-items {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  margin-bottom: 20px;
  border-spacing: 10px;
}

table#invoice-items tbody {
  max-height: 275px;
}

table#invoice-items td, table#invoice-items th {
  padding: 15px 30px;
}

table#invoice-items tr:hover td {
  background-color: transparent; /* or #000 */
}
</style>
